/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Video_ReadyInputs */

const en_us2_share_video_ready = /** @type {(inputs: Share_Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video ready.`)
};

const pt_br2_share_video_ready = /** @type {(inputs: Share_Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo pronto.`)
};

const es_419_share_video_ready = /** @type {(inputs: Share_Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video listo.`)
};

const pt_pt2_share_video_ready = /** @type {(inputs: Share_Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo pronto.`)
};

const fr_fr2_share_video_ready = /** @type {(inputs: Share_Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo prête.`)
};

const de_de2_share_video_ready = /** @type {(inputs: Share_Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video fertig.`)
};

const it_it2_share_video_ready = /** @type {(inputs: Share_Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video pronto.`)
};

/**
* | output |
* | --- |
* | "Video ready." |
*
* @param {Share_Video_ReadyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_video_ready = /** @type {((inputs?: Share_Video_ReadyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Video_ReadyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_video_ready(inputs)
	if (locale === "es-419") return es_419_share_video_ready(inputs)
	if (locale === "pt-PT") return pt_pt2_share_video_ready(inputs)
	if (locale === "fr-FR") return fr_fr2_share_video_ready(inputs)
	if (locale === "de-DE") return de_de2_share_video_ready(inputs)
	if (locale === "it-IT") return it_it2_share_video_ready(inputs)
	return en_us2_share_video_ready(inputs)
});
export { share_video_ready as "share.video_ready" }